import styled from 'styled-components';

export const Wrapper = styled.section(
  props => `
    display: flex;
    flex-direction: Column;
    width: 100%;
    margin-bottom: 7rem;
    h2 {
        font-size: 2.2rem;
        color: rgb(20, 24, 35);
        font-family: ${props.theme.font.fontFamily};
        font-weight: 600;
        padding-bottom: 1.5rem;
    }
`,
);
export const ContentWrapper = styled.div`
  background-color: rgb(255, 255, 255);
  box-shadow: rgba(0, 0, 0, 0.25) 0px 0.1rem 0.4rem 0px;
  border-radius: 0.6rem;
  padding: 3rem 2rem;
  display: flex;
  width: 100%;
  ul {
    display: flex;
    flex-direction: column;
    width: 100%;
    li {
      padding-bottom: 3rem;
    }
  }
`;
export const Question = styled.div`
  font-family: 'Rubik';
  font-size: 1.8rem;
  font-weight: 600;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-bottom:1.5rem;
  h3 { width: 90%; font-weight: 600; font-size: 1.8rem;}
`
export const Answer = styled.div`
    font-size: 1.6rem;
    line-height: 1.2;
`;